<template>
  <grid
    :model="getModel"
    name='Invoice Scanning'
    desc='Line Item Entry'
    search-placeholder='Scanned Invoices'
    fit-columns
    :search="true"
    :resizing="false"
    footer
    :endpoint='api.$.admin.getInvoicesToBeScannedHistory'
    alias='InvoiceScanHistory'
    :checkboxes="false"
    :tabs='tabs'
    ref='ScanInvoiceHIstoryGrid'
  >
    <back slot="back-action"/>
  </grid>
</template>

<script>

import Grid from '@/components/Grid'
import ScanInvoiceHistoryModel from './models/scan-invoice-history-model.js'
import { EventBus, Eved } from '@/event-bus'
import tabs from './tabs'
import back from './Components/back'

export default {
  components: {
    Grid,
    back
  },

  data () {
    return {
      ScanInvoiceHistoryModel,
      paymentInvoiceId: 0,
      tabs: tabs.tabs
    }
  },

  computed: {
    getModel() {
      return ScanInvoiceHistoryModel.get()
    }
  },

  methods: {
    openInvoice(paymentInvoiceId) {
      // this.redirectToUploadInvoicePage(paymentInvoiceId)
      this.refresh()
    },

    redirectToUploadInvoicePage(paymentInvoiceId) {
      window.location.reload(this.$router.replace('/d/InvoiceToPay/upload?invoiceId=' + paymentInvoiceId))
    },

    refresh() {
      this.$refs.ScanInvoiceHIstoryGrid.quickSearch()
      this.$refs.ScanInvoiceHIstoryGrid.onSelectAll(false)
    },

    handleButtons(r) {
      if (r && r.data && r.data.length === 1) {
        this.enableButtons(false)
        this.paymentInvoiceId = r.data[0].PaymentInvoiceId
      } else {
        this.enableButtons(true)
        this.paymentInvoiceId = 0
      }
    }
  },

  beforeDestroy() {
    EventBus.$emit(Eved.GENERIC.UNSELECTED_ALL)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/InvoiceScan/History.vue